/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { PageTitle } from '../../../_metronic/layout/core'
import axios from 'axios'
import { Link } from 'react-router-dom'

const DashboardPage: FC = () => {
  const [count_data, setcount_data] = useState<any>();
  const [dataloaded, setdataloaded] = useState(true);

  useEffect(() => {
    if (dataloaded) {
      getCount();
      setdataloaded(false);
    }
  }, [dataloaded]);

  const getCount = async () => {
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/admin/get-count-dashboard`);
    setcount_data(response.data);
  };

  return (
    <>
      <div className='row g-5 g-xl-10 mb-5 mb-xl-10'>
        {/* Invoices Stats */}
        <div className="col-12 col-sm-6 col-xl-4">
          <div className="shadow-sm rounded-3 mb-xl-10">
            <Link to={'/admin/manage-orders/orders'} className="text-decoration-none">
              <div className="d-flex align-items-center bg-light-primary rounded p-5 hover-elevate-up">
                <div className="flex-grow-1 me-5">
                  <span className="fw-bold fs-2x text-primary d-block">{count_data?.order_count}</span>
                  <span className="fw-semibold fs-6 text-gray-600">Invoices</span>
                </div>
                <div className="symbol symbol-50px">
                  <span className="symbol-label bg-primary">
                    <span className="svg-icon svg-icon-white svg-icon-2hx">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path opacity="0.3" d="M19 22H5C4.4 22 4 21.6 4 21V3C4 2.4 4.4 2 5 2H14L20 8V21C20 21.6 19.6 22 19 22Z" fill="currentColor" />
                        <path d="M15 8H20L14 2V7C14 7.6 14.4 8 15 8Z" fill="currentColor" />
                        <path d="M7 11H17V13H7V11Z" fill="currentColor" />
                        <path d="M7 15H13V17H7V15Z" fill="currentColor" />
                      </svg>
                    </span>
                  </span>
                </div>
              </div>
            </Link>
          </div>
        </div>

        {/* Orders Stats */}
        <div className="col-12 col-sm-6 col-xl-4">
          <div className="shadow-sm rounded-3 mb-xl-10">
            <Link to={'/admin/manage-orders/orders'} className="text-decoration-none">
              <div className="d-flex align-items-center bg-light-success rounded p-5 hover-elevate-up">
                <div className="flex-grow-1 me-5">
                  <span className="fw-bold fs-2x text-success d-block">{count_data?.order_count}</span>
                  <span className="fw-semibold fs-6 text-gray-600">Orders</span>
                </div>
                <div className="symbol symbol-50px">
                  <span className="symbol-label bg-success">
                    <span className="svg-icon svg-icon-white svg-icon-2hx">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path opacity="0.3" d="M4 4H20V20H4V4Z" fill="currentColor" />
                        <path d="M10 8H14V10H10V8Z" fill="currentColor" />
                        <path d="M10 12H14V14H10V12Z" fill="currentColor" />
                        <path d="M10 16H14V18H10V16Z" fill="currentColor" />
                      </svg>
                    </span>
                  </span>
                </div>
              </div>
            </Link>
          </div>
        </div>

        {/* Customers Stats */}
        <div className="col-12 col-sm-6 col-xl-4">
          <div className="shadow-sm rounded-3 mb-xl-10">
            <Link to={'/admin/user-management/users'} className="text-decoration-none">
              <div className="d-flex align-items-center justify-content-center bg-light-info rounded p-5 hover-elevate-up">
                <div className="flex-grow-1 me-5">
                  <span className="fw-bold fs-2x text-info d-block">{count_data?.customer_count}</span>
                  <span className="fw-semibold fs-6 text-gray-600">Customers</span>
                </div>
                <div className="symbol symbol-50px">
                  <span className="symbol-label bg-info">
                    <span className="svg-icon svg-icon-white svg-icon-2hx">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path opacity="0.3" d="M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2Z" fill="currentColor" />
                        <path d="M12 6C10.3431 6 9 7.34315 9 9C9 10.6569 10.3431 12 12 12C13.6569 12 15 10.6569 15 9C15 7.34315 13.6569 6 12 6Z" fill="currentColor" />
                        <path d="M12 14C10.3431 14 9 15.3431 9 17C9 17.5523 9.44772 18 10 18H14C14.5523 18 15 17.5523 15 17C15 15.3431 13.6569 14 12 14Z" fill="currentColor" />
                      </svg>
                    </span>
                  </span>
                </div>
              </div>
            </Link>
          </div>
        </div>

        {/* Leads Stats */}
        <div className="col-12 col-sm-6 col-xl-4">
          <div className="shadow-sm rounded-3 mb-xl-10">
            <Link to={'/admin/lead-management/leads'} className="text-decoration-none">
              <div className="d-flex align-items-center bg-light-warning rounded p-5 hover-elevate-up">
                <div className="flex-grow-1 me-5">
                  <span className="fw-bold fs-2x text-warning d-block">{count_data?.lead_count}</span>
                  <span className="fw-semibold fs-6 text-gray-600">Leads</span>
                </div>
                <div className="symbol symbol-50px">
                  <span className="symbol-label bg-warning">
                    <span className="svg-icon svg-icon-white svg-icon-2hx">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path opacity="0.3" d="M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2Z" fill="currentColor" />
                        <path d="M12 6C10.3431 6 9 7.34315 9 9C9 10.6569 10.3431 12 12 12C13.6569 12 15 10.6569 15 9C15 7.34315 13.6569 6 12 6Z" fill="currentColor" />
                        <path d="M12 14C10.3431 14 9 15.3431 9 17C9 17.5523 9.44772 18 10 18H14C14.5523 18 15 17.5523 15 17C15 15.3431 13.6569 14 12 14Z" fill="currentColor" />
                      </svg>
                    </span>
                  </span>
                </div>
              </div>
            </Link>
          </div>
        </div>

        {/* Cars Stats */}
        <div className="col-12 col-sm-6 col-xl-4">
          <div className="shadow-sm rounded-3 mb-xl-10">
            <Link to={'/admin/cars/brands'} className="text-decoration-none">
              <div className="d-flex align-items-center bg-light-danger rounded p-5 hover-elevate-up">
                <div className="flex-grow-1 me-5">
                  <span className="fw-bold fs-2x text-danger d-block">{count_data?.car_count}</span>
                  <span className="fw-semibold fs-6 text-gray-600">Cars</span>
                </div>
                <div className="symbol symbol-50px">
                  <span className="symbol-label bg-danger">
                    <span className="svg-icon svg-icon-white svg-icon-2hx">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path opacity="0.3" d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" fill="currentColor" />
                        <path d="M7 10H17V12H7V10Z" fill="currentColor" />
                        <path d="M7 14H17V16H7V14Z" fill="currentColor" />
                      </svg>
                    </span>
                  </span>
                </div>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

const DashboardWrapper: FC = () => {
  const intl = useIntl();
  return (
    <>
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({ id: 'MENU.DASHBOARD' })}</PageTitle>
      <DashboardPage />
    </>
  );
};

export { DashboardWrapper };